import { render, staticRenderFns } from "./convenienceServe.vue?vue&type=template&id=14fe09b8&scoped=true"
import script from "./convenienceServe.vue?vue&type=script&lang=js"
export * from "./convenienceServe.vue?vue&type=script&lang=js"
import style0 from "./convenienceServe.vue?vue&type=style&index=0&id=14fe09b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14fe09b8",
  null
  
)

export default component.exports